import { useQsFilters } from "@dash/filters";
import { getMonth, getYear } from "date-fns";

import { regionProfitMetricsFiltersSerializer } from "@megaron/megarax-uri";
import { Month } from "@megaron/serializers";

export const getStartMonth = (date: Date) => {
  const month = getMonth(date);
  return month > 0 ? month : 12;
};

export const getStartYear = (date: Date) => {
  const month = getMonth(date);
  const year = getYear(date);
  return month > 0 ? year : year - 1;
};

export const getDateString = (month: number, year: number) => {
  return `${year}-${month.toString().padStart(2, "0")}` as Month;
};

export const useRegionProfitMetricsFilters = () => {
  const defaultFilters = {
    startDate: getDateString(getStartMonth(new Date()), getStartYear(new Date())),
    endDate: getDateString(getMonth(new Date()) + 1, getYear(new Date())),
  };

  const { filters, setFilters } = useQsFilters(regionProfitMetricsFiltersSerializer, defaultFilters);

  return {
    filters: {
      startDate: filters.startDate ?? defaultFilters.startDate,
      endDate: filters.endDate ?? defaultFilters.endDate,
    },
    setFilters,
  };
};
